$(function() {

  // set active thumb by index within a specific productBox
  // $productBox - jQuery element for the productBox container
  function setActiveByIndex($productBox, index) {
    if (!$productBox || !$productBox.length) return false;

    var $carousel = $productBox.find('.gempages_gallery-carousel-wrapper').first();
    var $root = $productBox.find('.gempages_gallery-main').first();
    if (!$carousel.length || !$root.length) return false;

    var $thumbs = $carousel.find('.gempages_gallery-carousel-cell');
    if (!$thumbs.length) return false;

    var $target = $thumbs.filter('[data-index="' + index + '"]');
    if (!$target.length) return false;

    // update active class (only within this carousel)
    $thumbs.removeClass('active');
    $target.addClass('active');

    // update main image src (only within this main)
    var $mainImg = $root.find('.gempages_gallery-main-img img');
    var src = $target.find('img').attr('src');
    if ($mainImg.length && src) {
      $mainImg.attr('src', src);
    }

    // scroll thumbnail into view (smooth) inside its container
    try {
      $target.get(0).scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } catch (e) {}

    return true;
  }

  // thumbnail click (delegated) - only affects its own productBox
  $(document).on('click', '.gempages_gallery-carousel-cell', function(e) {
    var $cell = $(this);
    var idx = $cell.attr('data-index');

    var $productBox = $cell.closest('.productBox');
    if (!$productBox.length) return;

    setActiveByIndex($productBox, idx);
  });

  // arrows (delegated) - only affects the gallery instance inside its productBox
  $(document).on('click', '.gempages_gallery-next, .gempages_gallery-prev', function(e) {
    e.preventDefault();

    var $btn = $(this);
    var $productBox = $btn.closest('.productBox');
    if (!$productBox.length) return;

    var $carousel = $productBox.find('.gempages_gallery-carousel-wrapper').first();
    var $thumbs = $carousel.find('.gempages_gallery-carousel-cell');
    if (!$thumbs.length) return;

    var $current = $thumbs.filter('.active');
    var currentIndex = parseInt($current.attr('data-index') || '1', 10);
    var maxIndex = $thumbs.length;
    var nextIndex = currentIndex;

    if ($btn.is('.gempages_gallery-next')) {
      nextIndex = currentIndex + 1;
      if (nextIndex > maxIndex) nextIndex = 1; // wrap
    } else {
      nextIndex = currentIndex - 1;
      if (nextIndex < 1) nextIndex = maxIndex; // wrap
    }

    setActiveByIndex($productBox, nextIndex);
  });

  // ensure initial active per productBox
  function ensureInitialActive() {
    $('.productBox').each(function() {
      var $productBox = $(this);
      var $carousel = $productBox.find('.gempages_gallery-carousel-wrapper').first();
      var $root = $productBox.find('.gempages_gallery-main').first();
      if (!$carousel.length || !$root.length) return;

      var $thumbs = $carousel.find('.gempages_gallery-carousel-cell');
      if (!$thumbs.length) return;

      var $active = $thumbs.filter('.active').first();
      if (!$active.length) {
        setActiveByIndex($productBox, 1);
      } else {
        var src = $active.find('img').attr('src');
        if (src) $root.find('.gempages_gallery-main-img img').attr('src', src);
      }
    });
  }

  // run once on load
  ensureInitialActive();

  // ---- Swipe support scoped to each productBox instance ----
  (function(){
    var threshold = 30;      // minimum horizontal px for swipe
    var restraint = 75;      // maximum vertical px allowed
    var allowedTime = 500;   // maximum time allowed to consider a swipe (ms)

    // store start data on the main element via jQuery .data()
    $(document).on('touchstart pointerdown', '.productBox .gempages_gallery-main', function(e){
      var ev = e.originalEvent || e;
      var point;
      if (ev.touches && ev.touches.length) point = ev.touches[0];
      else point = ev;
      $(this).data('swipeStart', {
        x: point.clientX,
        y: point.clientY,
        t: new Date().getTime()
      });
    });

    $(document).on('touchend pointerup', '.productBox .gempages_gallery-main', function(e){
      var ev = e.originalEvent || e;
      var point;
      if (ev.changedTouches && ev.changedTouches.length) point = ev.changedTouches[0];
      else point = ev;

      var start = $(this).data('swipeStart');
      if (!start) return;

      var distX = point.clientX - start.x;
      var distY = point.clientY - start.y;
      var elapsed = new Date().getTime() - start.t;

      if (elapsed <= allowedTime && Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        var $productBox = $(this).closest('.productBox');
        if (! $productBox.length) return;

        if (distX < 0) {
          // left swipe -> next
          $productBox.find('.gempages_gallery-next').first().trigger('click');
        } else {
          // right swipe -> prev
          $productBox.find('.gempages_gallery-prev').first().trigger('click');
        }
      }

      $(this).removeData('swipeStart');
    });

    // Prevent accidental selection while swiping
    $(document).on('dragstart selectstart', '.productBox .gempages_gallery-main', function(e){ e.preventDefault(); });

  })();

  // Optional: If getVariant() replaces galleries inside a productBox, call ensureInitialActive()
  // at the end of getVariant() to immediately sync the new gallery:
  // ensureInitialActive();

});